import { useEffect, useRef } from 'react';
import { Link,useLocation} from 'react-router-dom';


// ===== LOGO =====
export function Logo({style }) {

  return (
    <Link to="/" className="header-logo"  style={style}>
      <div className="logo-icon">
        <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
          />
        </svg>
      </div>
      Cev<span>FİN</span>
    </Link>
  );
}

// ===== FADE IN WRAPPER =====
export function FadeIn({ children, delay = 0, style = {} }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('visible');
          observer.unobserve(el);
        }
      },
      { threshold: 0.12 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className="fade-in" style={{ transitionDelay: `${delay}s`, ...style }}>
      {children}
    </div>
  );
}

// ===== ICON BOX =====
export function IconBox({ children, size = 'md' }) {
  return (
    <div className={`icon-box ${size === 'lg' ? 'icon-box-lg' : ''}`}>
      {children}
    </div>
  );
}

// ===== SECTION HEADER =====
export function SectionHeader({ label, title, desc, center = false }) {
  return (
    <div style={center ? { textAlign: 'center', maxWidth: 600, margin: '0 auto 64px' } : { marginBottom: 64 }}>
      <FadeIn>
        <div className="section-label">{label}</div>
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: title }} />
        {desc && <p className="section-desc" style={center ? { margin: '0 auto' } : {}}>{desc}</p>}
      </FadeIn>
    </div>
  );
}
